import {Dialog} from 'platform/components';
import {Box, getSize} from 'platform/foundation';

import {ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

/** `xLarge`'s 16px side margin plus 16px of dialog body padding, per side. */
const DIALOG_HORIZONTAL_INSET = 16;

interface SourcingMobileDialogProps extends TestIdProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Platform `Dialog` has no mobile mode: its panel is centred by flexbox and keeps its own side
 * margin, so full-width content makes the panel wider than the viewport and centring pushes it
 * off screen. `xLarge` is the only size with a 16px rather than 60px margin; capping the content
 * at the viewport minus that inset keeps the panel on screen.
 */
export function SourcingMobileDialog(props: SourcingMobileDialogProps) {
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={props.title}
      size="xLarge"
      data-testid={props['data-testid']}
    >
      <Box maxWidth={`calc(100vw - ${getSize(DIALOG_HORIZONTAL_INSET)})`}>{props.children}</Box>
    </Dialog>
  );
}
